import { Box } from '@mui/material';

const BackImage = ({ image }) => {
  return (
    <Box
      sx={{
        backgroundColor: '#141516',
        display: 'flex',
        justifyContent: { xs: 'center', lg: 'flex-end' },
        '& img': {
          width: '100%',
          height: '100%',
          objectFit: 'cover',
        },
        position: 'absolute',
        marginLeft: 'auto',
        overflow: 'hidden',
        width: { xs: '100%', md: '700px', lg: '60vw' },
        height: '100%',
        left: 0,
        bottom: 0,
        right: 0,
        top: 0,
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          height: { xs: 160, tl: 'auto' },
        }}
      >
        <img src={image} alt="" loading="lazy" />
        <Box
          sx={{
            background: {
              xs: 'linear-gradient(360deg, #151617 0%, rgba(21, 22, 23, 0.64) 100%)',
              tl: 'linear-gradient(91deg, #151617 0.41%, rgba(21, 22, 23, 0.00) 99.54%)',
            },
            position: 'absolute',
            overflow: 'hidden',
            width: '100%',
            height: '100%',
            left: 0,
            bottom: 0,
            right: 0,
            top: 0,
          }}
        />
      </Box>
    </Box>
  );
};

export default BackImage;
